import PropTypes from "prop-types";
import { useState } from "react";

const OtpController = () => {
  const initUser = {
    pin: "",
    user: ""
  };
  const [usr, setUser] = useState(initUser);
  const [validations, setValidation] = useState({
    err: {
      pin: "",
      user: ""
    },
    err_msg: ""
  });
  // HANDLE CHANGES
  const handleChange = event => {
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setUser({ ...usr, [name]: value });
    setValidation({
      ...validations,
      err_msg: ""
    });
  };

  return {
    handleChange,
    usr,
    validations
  };
};

export default OtpController;

OtpController.propTypes = {
  otp: PropTypes.string
};
